/*
* ===============================================================================================================
*                                Copyright 2021, Blue Yonder Group, Inc.
*                                           All Rights Reserved
*
*                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
*                                          BLUE YONDER GROUP, INC.
*
*
*                         The copyright notice above does not evidence any actual
*                                 or intended publication of such source code.
*
* ===============================================================================================================
*/

import {
  SET_NO_ORGANIZATION,
  GET_ORGANIZATIONS_LIST,
  GET_APPLICATIONS_FOR_ORGANIZATION,
  GET_MODULES_FOR_APPLICATION,
  SET_GLOBAL_ROLE_BUILTIN_POLICIES,
  ADD_MODULE,
  SET_BUILTIN_POLICIES_TO_ASSOCIATE,
  CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE
} from './types';

const initialState = {
  organizations: [],
  applicationsForOrganization: [],
  noOrganization: false,
  modulesForApplication: [],
  builtinPoliciesByRoleId: {},
  modulesById: {},
  builtinPoliciesToAssociate: {
    entities: [],
    page: {}
  }
};

export const globalRoleReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case GET_ORGANIZATIONS_LIST:
      return {
        ...state,
        organizations: action.organizations
      }
    case GET_APPLICATIONS_FOR_ORGANIZATION:
      return {
        ...state,
        applicationsForOrganization: action.applicationsForOrganization
      }
    case GET_MODULES_FOR_APPLICATION:
      return {
        ...state,
        modulesForApplication: action.modulesForApplication
      }
    case SET_NO_ORGANIZATION:
      return {
        ...state,
        noOrganization: action.noOrganization
      }
    case SET_GLOBAL_ROLE_BUILTIN_POLICIES:
      return {
        ...state,
        builtinPoliciesByRoleId: {
          ...state.builtinPoliciesByRoleId,
          [action.roleId]: action.builtinPolicies
        }
      };
    case ADD_MODULE:
      return {
        ...state,
        modulesById: {
          ...state.modulesById,
          [action.module.id]: action.module
        }
      };
    case SET_BUILTIN_POLICIES_TO_ASSOCIATE:
      return {
        ...state,
        builtinPoliciesToAssociate: {
          entities: action.entities,
          page: action.page
        }
      };
    case CLEAR_BUILTIN_POLICIES_TO_ASSOCIATE:
      return {
        ...state,
        builtinPoliciesToAssociate: initialState.builtinPoliciesToAssociate
      };
    default:
      return state;
  }
}